<div class=" o-modal--alert o-modal__error--gris o-modal--medium" id="mod-mod-req2" style="width: 100%;">
    <div class="o-modal__head">
        <a class="o-modal__close close-modal" matDialogClose></a>
        <label class="o-title o-title--white o-title--medium">{{ 'ModalRejectPolicyPortal.titleReject' | translate }}</label>
    </div>


    <div class="o-modal__body">
        <p>{{ 'ModalRejectPolicyPortal.bodyReject' | translate }}</p>
        <textarea input class="o-form__textarea" placeholder="{{ 'ModalRejectPolicyPortal.placeholderComment' | translate}}" [(ngModel)]="observation"></textarea>
    </div>
    <div class="o-modal__footer">
        <div>
            <button mat-button mat-dialog-close class="btn btn--default">{{ 'ModalRejectPolicyPortal.btnCancel' | translate }} </button>
            <button mat-button class="btn btn--primary" (click)="onSubmit()">{{ 'ModalRejectPolicyPortal.btnReject' | translate }}</button>
        </div>
    </div>

</div>